import { useMemo } from 'react';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetSubProgramPreferenceProgressScurve } from 'api/queries/getPrefferedSPIMethod.query';
import { useQueryGetSubProgramPreferencePartialCompletion } from 'api/queries/getSubProgramPreferencePartialCompletion.query';

import {
    getDecodedValue,
    getEncodeValue,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/programProgressOverview.utils';

export const useProgressMeasurement = (isApiEnabled = true) => {
    const { contract } = useProjectTreeStore();
    const { data: progressMeasurementDefaultValue, refetch: refetchProgressMeasurement } =
        useQueryGetSubProgramPreferenceProgressScurve({
            subProgramId: contract?.id,
            enabled: isApiEnabled,
        });

    const { data: partialCompletionCreditDefaultValue, refetch: refetchPartialCompletionCredit } =
        useQueryGetSubProgramPreferencePartialCompletion({
            subProgramId: contract?.id,
            enabled: isApiEnabled,
        });

    const value = useMemo(() => {
        return progressMeasurementDefaultValue && partialCompletionCreditDefaultValue
            ? getEncodeValue(progressMeasurementDefaultValue, partialCompletionCreditDefaultValue)
            : undefined;
    }, [progressMeasurementDefaultValue, partialCompletionCreditDefaultValue]);

    const decodedValue = useMemo(() => {
        return value ? getDecodedValue(value) : undefined;
    }, [value]);

    const refetch = () => {
        Promise.all([refetchProgressMeasurement(), refetchPartialCompletionCredit()]);
    };

    return { value, decodedValue, refetch };
};
